export const BaseLoader = ()=>{
    return <div className="spinner-border spinner-border-sm" role="status">
    </div>
}